import Index from '@/page/partyTraining/index'
import Content from '@/page/partyTraining/content'

const routes = [
  {
    path: '/partyTraining',
    component: Index
  }, {
    path: '/partyTraining/content/:id',
    component: Content
  }
]

export default {
  routes
}



// WEBPACK FOOTER //
// ./src/router/router-partyTraining.js